import { GuidebookArticleCardProps } from 'components/content/guidebook/guidebookArticleCard/GuidebookArticleCard'
import { getLinkPropsByArticleSlug } from 'components/content/guidebook/utils'
import { HighlightedParagraphProps } from 'components/highlightedParagraph/HighlightedParagraph'
import { colors } from 'utils/colors'
import { NumberRange } from 'utils/types'

export const stepAffairsInOrderData: Record<
  NumberRange<7>,
  Pick<HighlightedParagraphProps, 'icon' | 'linkProps'>
> = {
  '1': {
    icon: 'TimelineClock',
    linkProps: getLinkPropsByArticleSlug('create-a-bucket-list-in-6-steps-with-101-unique-ideas'),
  },
  '2': {
    icon: 'FuneralDirective',
    linkProps: getLinkPropsByArticleSlug('how-to-preplan-your-funeral-step-by-step'),
  },
  '3': {
    icon: 'Will',
    linkProps: { href: '/articles/creating-your-free-will-in-7-easy-steps-with-goodtrust' },
  },
  '4': {
    icon: 'HealthCareDirective',
    linkProps: getLinkPropsByArticleSlug('advance-directive-what-it-is-and-how-to-create-one'),
  },
  '5': {
    icon: 'ShieldCheck',
    linkProps: getLinkPropsByArticleSlug('how-to-make-decisions-about-guardianship-in-a-will'),
  },
  '6': {
    icon: 'PowerOfAttorney',
    linkProps: getLinkPropsByArticleSlug(
      'what-is-power-of-attorney-how-to-assign-an-agent-and-more-or-goodtrust'
    ),
  },
  '7': {
    icon: 'Executor',
    linkProps: getLinkPropsByArticleSlug('how-to-choose-the-right-executor-for-a-will'),
  },
}

export const stepDigitalLegacyLinkProps: Record<
  NumberRange<2>,
  Pick<HighlightedParagraphProps, 'linkProps'>
> = {
  '1': {
    linkProps: getLinkPropsByArticleSlug(
      'video-goodtrust-co-founder-digital-legacy-is-the-story-of-you'
    ),
  },
  '2': { linkProps: getLinkPropsByArticleSlug('what-happens-to-our-digital-data-after-we-die') },
}

export const stepMemorializeData: Record<
  NumberRange<6>,
  Pick<HighlightedParagraphProps, 'icon' | 'linkProps' | 'title'>
> = {
  '1': {
    icon: 'ColorFacebook',
    linkProps: getLinkPropsByArticleSlug('how-to-deactivate-a-facebook-account-when-someone-dies'),
    title: 'Facebook',
  },
  '2': {
    icon: 'ColorInstagram',
    linkProps: getLinkPropsByArticleSlug(
      'how-to-deactivate-an-instagram-account-when-someone-dies'
    ),
    title: 'Instagram',
  },
  '3': {
    icon: 'ColorTikTok',
    linkProps: getLinkPropsByArticleSlug('how-to-deactivate-a-tiktok-account-when-someone-dies'),
    title: 'TikTok',
  },
  '4': {
    icon: 'ColorTwitter',
    linkProps: getLinkPropsByArticleSlug('how-to-deactivate-a-twitter-account-when-someone-dies'),
    title: 'Twitter',
  },
  '5': {
    icon: 'ColorLinkedIn',
    linkProps: getLinkPropsByArticleSlug('how-to-deactivate-a-linkedin-account-when-someone-dies'),
    title: 'LinkedIn',
  },
  '6': {
    icon: 'ColorSnapchat',
    linkProps: getLinkPropsByArticleSlug('how-to-deactivate-a-snapchat-account-when-someone-dies'),
    title: 'Snapchat',
  },
}

export const stepCloseAccountsData: Record<
  NumberRange<8>,
  Pick<HighlightedParagraphProps, 'icon' | 'iconProps' | 'linkProps'>
> = {
  '1': {
    icon: 'Mail',
    iconProps: { size: '2rem', css: { color: `${colors.blue[500]} !important` } },
    linkProps: getLinkPropsByArticleSlug(
      'how-to-forward-or-stop-mail-for-the-deceased-and-list-of-organizations-to'
    ),
  },
  '2': {
    icon: 'ColorYahoo',
    iconProps: { width: '3.5rem', height: '2rem' },
    linkProps: getLinkPropsByArticleSlug(
      'how-to-deactivate-a-yahoo-account-when-someone-dies-with-or-without-password'
    ),
  },
  '3': {
    icon: 'ColorVenmo',
    iconProps: { width: '3.5rem', height: '2rem' },
    linkProps: getLinkPropsByArticleSlug('how-to-deactivate-a-venmo-account-when-someone-dies'),
  },
  '4': {
    icon: 'ColorMicrosoft',
    linkProps: getLinkPropsByArticleSlug('how-to-deactivate-a-microsoft-account-when-someone-dies'),
  },
  '5': {
    icon: 'ColorGoogle',
    linkProps: getLinkPropsByArticleSlug(
      'how-to-deactivate-a-google-or-youtube-account-when-someone-dies'
    ),
  },
  '6': {
    icon: 'Apple',
    linkProps: getLinkPropsByArticleSlug('how-to-deactivate-an-apple-account-when-someone-dies'),
  },
  '7': {
    icon: 'ColorTinder',
    linkProps: getLinkPropsByArticleSlug('how-to-deactivate-a-tinder-account-when-someone-dies'),
  },
  '8': {
    icon: 'ColorSpotify',
    linkProps: getLinkPropsByArticleSlug(
      'how-to-delete-your-spotify-account-or-memorialize-playlists'
    ),
  },
}

export const stepLovedOneData: Record<
  NumberRange<5>,
  Pick<GuidebookArticleCardProps, 'image' | 'linkProps'>
> = {
  '1': {
    image: <img src={`/images/guidebook/digital-memories.jpg`} alt="" />,
    linkProps: { href: '/memories' },
  },
  '2': {
    image: <img src={`/images/guidebook/memorial-ideas.jpg`} alt="" />,
    linkProps: getLinkPropsByArticleSlug('8-creative-ideas-to-memorialize-loved-ones'),
  },
  '3': {
    image: (
      <img
        src={`/images/guidebook/obituary.jpg`}
        srcSet={`
            /images/guidebook/obituary.jpg 1x,
            /images/guidebook/obituary@2x.jpg 2x,
          `}
        alt=""
      />
    ),
    linkProps: getLinkPropsByArticleSlug('how-to-write-a-great-obituary-with-examples'),
  },
  '4': {
    image: (
      <img
        src={`/images/guidebook/funeral.jpg`}
        srcSet={`
            /images/guidebook/funeral.jpg 1x,
            /images/guidebook/funeral@2x.jpg 2x,
          `}
        alt=""
      />
    ),
    linkProps: getLinkPropsByArticleSlug('everything-you-need-to-know-about-funeral-directives'),
  },
  '5': {
    image: (
      <img
        src={`/images/guidebook/celebration-of-life.jpg`}
        srcSet={`
            /images/guidebook/celebration-of-life.jpg 1x,
            /images/guidebook/celebration-of-life@2x.jpg 2x,
          `}
        alt=""
      />
    ),
    linkProps: getLinkPropsByArticleSlug('how-to-plan-a-celebration-of-life-guide-and-ideas'),
  },
}

export interface GuidebookStep {
  id: 'affairs' | 'legacy' | 'accounts' | 'cancel' | 'plan'
  no: NumberRange<5>
}

export const guidebookSteps: GuidebookStep[] = [
  {
    id: 'affairs',
    no: 1,
  },
  {
    id: 'legacy',
    no: 2,
  },
  {
    id: 'accounts',
    no: 3,
  },
  {
    id: 'cancel',
    no: 4,
  },
  {
    id: 'plan',
    no: 5,
  },
]

export const getGuidebookStepById = (id: GuidebookStep['id']) =>
  guidebookSteps.find((s) => s.id === id) as GuidebookStep
